export const getSessionAttribute = (key) => {
    const sessionDetails = localStorage.getItem('paymentSession') ? JSON.parse(localStorage.getItem('paymentSession')) : {};
    return Object.values(sessionDetails).length > 0 ? sessionDetails?.[key] : ''
}